module.exports = __webpack_public_path__ + "static/img/title.2595fb33.png";